module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: 'el-icon-' + _vm.name
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fda09d80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/element-ui/packages/icon/src/icon.vue
// module id = 1150
// module chunks = 1